/* eslint-disable max-statements, complexity */
import { fromJS } from 'immutable';
import {
  GET_ALERT_BALANCE,
  GET_ALERT_BALANCE_FAILURE,
  GET_ALERT_BALANCE_SUCCESS,
  UPDATE_SWEEP_ALERT,
  UPDATE_SWEEP_ALERT_SUCCESS,
  UPDATE_SWEEP_ALERT_FAILURE,
  GET_TRANSACTION_LIST,
  GET_TRANSACTION_LIST_SUCCESS,
  GET_TRANSACTION_LIST_FAILURE,
} from '../../constants/actionTypes';

export const initialState = fromJS({
  isLoader: false,
});

const loader = (state = initialState, action) => {
  if (action.type) {
    if (action.type === GET_ALERT_BALANCE) {
      return state.set('isLoader', true);
    }
    if (action.type === GET_ALERT_BALANCE_FAILURE) {
      return state.set('isLoader', false);
    }
    if (action.type === GET_ALERT_BALANCE_SUCCESS) {
      return state.set('isLoader', false);
    }
    if (action.type === UPDATE_SWEEP_ALERT) {
      return state.set('isLoader', true);
    }
    if (action.type === UPDATE_SWEEP_ALERT_SUCCESS) {
      return state.set('isLoader', false);
    }
    if (action.type === UPDATE_SWEEP_ALERT_FAILURE) {
      return state.set('isLoader', false);
    }
    if (action.type === GET_TRANSACTION_LIST) {
      return state.set('isLoader', true);
    }
    if (action.type === GET_TRANSACTION_LIST_SUCCESS) {
      return state.set('isLoader', false);
    }
    if (action.type === GET_TRANSACTION_LIST_FAILURE) {
      return state.set('isLoader', false);
    }
  }
  return state;
};
export default loader;
